var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3706(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.627,
    height: 22.627,
    viewBox: "0 0 22.627 22.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3706",
    "data-name": "Group 3706",
    transform: "translate(-334 -98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2096",
    "data-name": "Rectangle 2096",
    transform: "translate(345.313 98) rotate(45)",
    fill: "#28599b",
    stroke: "#28599b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-share-alt",
    "data-name": "Icon ionic-md-share-alt",
    d: "M12.366,9.863,9.088,6.75V8.5C6.029,8.935,4.937,11.12,4.5,13.3a5.019,5.019,0,0,1,4.588-2.229v1.792Z",
    transform: "translate(336.5 99.25)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3706);
export default __webpack_public_path__ + "static/media/Group 3706.b980e86c1696bd6046d209b9d8fe8086.svg";
export { ForwardRef as ReactComponent };